import * as params from '../util/params'

import * as util from '../util/util'

import * as ws_base from '../ws/ws_base'



const DOMINIO = "chat";




export async function buscarMensagensPorChat(id_chat, id_proposta){

	return await ws_base.get(DOMINIO, "obter_mensagens", {"id_chat": id_chat, "id_proposta": id_proposta});
}


export async function enviarMensagem(id_remetente, mensagem, id_chat){

	let retorno= await ws_base.post(DOMINIO, "novo", {"id_chat": id_chat, 
													"id_remetente": id_remetente, 
														"mensagem": mensagem});
															
	
	console.log(retorno);
	
	if (retorno!=null && retorno.id !=null)	
		return retorno.id;

	return null;
}